import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bepatient-skeleton',
  templateUrl: './bepatient-skeleton.component.html',
  styleUrls: ['./bepatient-skeleton.component.scss'],
  standalone: false
})
export class BepatientSkeletonComponent implements OnInit {
  @Input() className: string;
  @Input() type: string;
  @Input() numOptions = 1; // by default: 1

  constructor() {}

  ngOnInit(): void {}
}
